import { reorderMultiDrag } from './reorderMultiDrag';
import { reorderSingleDrag } from './reorderSingleDrag';

export const mutliDragAwareReorder = (args) => {
	const isMultiDrag = args.pageIdsSelected.length > 1;
	if (isMultiDrag) return reorderMultiDrag(args);
	return reorderSingleDrag(args);
};
